import { combineReducers, configureStore, Middleware } from '@reduxjs/toolkit';
import {
  createThrowOnReject,
  dialogReducer,
  logout,
  snackbarReducer,
  userReducer
} from '@ianesthesie-kit/redux';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { doctorBffApi } from '@/modules';
import { appUiReducer } from '@/modules/ui';
import { appContextReducer } from '@/modules/appContext';
import { listenerMiddleware } from './listener';
import { redirectOn401 } from './middleware';
import {
  deskPaymentRegistryReducer,
  invoiceBuilderReducer
} from '@/modules/billing';
import { miscReducer } from './misc.slice';

const throwOnRejectExcludeDoctorBffApi: Middleware = createThrowOnReject({
  excludedActions: ['doctorBffApi/']
});

const combinedUiReducer = combineReducers({
  snackbar: snackbarReducer,
  dialog: dialogReducer,
  app: appUiReducer
});

const combinedReducer = combineReducers({
  auth: userReducer,
  ui: combinedUiReducer,
  appContext: appContextReducer,
  invoiceBuilder: invoiceBuilderReducer,
  deskPaymentRegistry: deskPaymentRegistryReducer,
  misc: miscReducer,
  [doctorBffApi.reducerPath]: doctorBffApi.reducer
});

const rootReducer: typeof combinedReducer = (state, action) => {
  if (logout.fulfilled.match(action)) {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export const appStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat(doctorBffApi.middleware)
      .concat(redirectOn401)
      .concat(throwOnRejectExcludeDoctorBffApi)
});

setupListeners(appStore.dispatch);

export type RootState = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;
